import { useLocation, Navigate, Outlet } from "react-router-dom"
import { AUTH_TOKEN } from "../../constants/authToken"

const RequireAuth = () => {
    const token = localStorage.getItem(AUTH_TOKEN);
    const location = useLocation();

    return (
        token
            ? <Outlet />
            // `replace` so the protected route never enters history. Without it,
            // browser-back from /login lands on (e.g.) /trade/btcusd, which then
            // immediately redirects back to /login — making back appear broken.
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}
export default RequireAuth